import React, { useEffect, useState, useCallback } from 'react';
import { Icon, Spin, Table, message } from 'antd';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import Widget from 'components/Widget';
import FormFilter from './FormFilter';
import Columns from './Columns';
import { EditableCell, EditableFormRow } from './EditableCell';
import { fetchCampaign, updateCampaign, resetAddCampaign, deleteCampaign } from 'appRedux/actions/Campaign';
import { fetchIndustry } from 'appRedux/actions/Industry';
import { fetchCategory } from 'appRedux/actions/Category';
import convertData from 'firebase/utils/convertData';

const ListingCampaign = ({ campaignList, loading, isShowMore, fetchCampaign, updateCampaign, deleteCampaign, loadMoreCampaign, currentUser, resetAddCampaign, fetchIndustry, fetchCategory, payload, updating, deleting, industryList, categoryList, loadingIndustry, loadingCategory }) => {
  const [dataSource, setDataSource] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [processing, setProcessing] = useState(false);
  const convertedData = isEmpty(campaignList) ? [] : convertData(campaignList, true, true);
  const industries = isEmpty(industryList) ? [] : convertData(industryList, true, true);
  const categories = isEmpty(categoryList) ? [] : convertData(categoryList, true, true);

  const components = {
    body: {
      row: EditableFormRow,
      cell: EditableCell,
    },
  };

  const handleUpdate = (id) => {
    const inputData = dataSource.length === 0 ? convertedData : dataSource;
    const updateData = inputData.find(data => data.id === id);
    updateData.updated_at = moment().unix();
    updateData.updated_by = currentUser;
    setProcessing(id);
    updateCampaign({params: updateData});
  };

  const handleDelete = (id) => {
    setProcessing(id);
    deleteCampaign({params: id});
  };

  const columns = Columns(disableSubmit, processing, updating, deleting, handleUpdate, handleDelete).map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleUpdateRow,
        handleError,
        disabled: updating || deleting,
      }),
    };
  });

  const handleUpdateRow = row => {
    const newData = dataSource.length === 0 ? [...convertedData] : [...dataSource];
    const index = newData.findIndex(item => row.index === item.index);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
  };

  const handleToggle = () => {
    setToggle(!toggle);
  };

  const handleFetchData = useCallback((filter = null) => {
    const filterParams = filter ? { ...filter } : {};
    fetchCampaign({
      filter: filterParams,
    });
  }, [fetchCampaign]);

  const handleError = (id) => {
    setDisableSubmit(id);
  };

  useEffect(() => {
    if (payload.message) {
      if (payload.code === 200) {
        message.success({ content: payload.message, key: 'updatable', duration: 2 });
      } else {
        message.error({ content: payload.message, key: 'updatable', duration: 2 });
      }
      resetAddCampaign();
    }
  }, [payload.code, payload.message, resetAddCampaign]);

  useEffect(
    () => {
      fetchIndustry();
      fetchCategory();
      handleFetchData();
    },
    [handleFetchData, fetchCategory, fetchIndustry]
  );

  return (
    <Spin spinning={!currentUser} tip="Đang tải dữ liệu...">
      <Widget
        styleName="gx-order-history"
        title={<h2 className="h4 gx-text-capitalize gx-mb-0">Tra cứu dữ liệu campaign</h2>}
        extra={
          <p onClick={handleToggle} className="gx-text-primary gx-mb-0 gx-pointer">
            {toggle ? (
              <>
                <Icon type="up-circle" /> Đóng tìm kiếm
              </>
            ) : (
              <>
                <Icon type="search" /> Bạn cần tìm kiếm dữ liệu ?
              </>
            )}
          </p>
        }
      >
        {toggle && <FormFilter campaigns={convertedData} industries={industries} categories={categories} loadingCampaign={loading} loadingCategory={loadingCategory} loadingIndustry={loadingIndustry} onSearch={filter => handleFetchData(filter)} />}
        <Table
          rowKey='id'
          loading={loading}
          className='gx-table-no-bordered'
          pagination={false}
          bordered={false}
          size='small'
          components={components}
          rowClassName={() => 'editable-row'}
          dataSource={convertedData}
          columns={columns}
        />
      </Widget>
    </Spin>
  );
};

const mapStateToProps = ({ campaign, auth, industry, category }) => {
  const { data: campaignList, loading, updating, deleting, payload } = campaign;
  const { data: industryList, loading: loadingIndustry } = industry;
  const { data: categoryList, loading: loadingCategory } = category;
  const { currentUser } = auth;
  return { campaignList, loading, deleting, currentUser, payload, updating, industryList, categoryList, loadingIndustry, loadingCategory };
};

export default connect(
  mapStateToProps,
  { fetchCampaign, updateCampaign, resetAddCampaign, deleteCampaign, fetchIndustry, fetchCategory }
)(ListingCampaign);
